import { useEffect, useState } from "react";
// MUI Icons
import SchoolIcon from '@mui/icons-material/School';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ClassIcon from '@mui/icons-material/Class';
import "./module.css";

function CourseBatchModal({ onClose }) {
	const [subjectData, setSubjectData] = useState([]); // Default to empty array
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const fetchSubject = async () => {
		try {
			const token = sessionStorage.getItem("token");
			const apiUrl = process.env.REACT_APP_BASE_URL;

			const response = await fetch(
				`${apiUrl}/Student/FetchStudentClassDetails`,
				{
					method: "POST",
					headers: {
						"Content-Type": "application/json",
						Authorization: token,
					},
					body: JSON.stringify({
						studentID: sessionStorage.getItem("employeeId"),
					}),
				}
			);

			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}

			const data = await response.json();

			// Handle "Record Not Found" case
            // if (data.msg === "Record Not Found" || data.data === null || !data.data) {
			// 	setSubjectData([]); // Set to empty array
			// 	return;
			// }

			if (
    data.msg === "Record Not Found" || 
    data.data === null || 
    (Array.isArray(data.data) && data.data.length === 0) ||
    (Array.isArray(data) && data.length === 0)
) {
    setSubjectData([]);
    return;
}


// Extract the subjects array
let subjects = [];
if (Array.isArray(data.data)) {
    subjects = data.data;
} else if (Array.isArray(data)) {
    subjects = data;
}

setSubjectData(subjects);
			
			// Assuming the actual list is inside data.data (common pattern)
			// Adjust this based on your real successful response structure!
        //    const subjects = Array.isArray(data.data) ? data.data : data;
		   // Final safety: ensure it's an array
			setSubjectData(Array.isArray(subjects) ? subjects : []);
		} catch (err) {
			setError(err.message);
			console.error("Fetch error:", err);
		} finally {
			setLoading(false);
		}
	};

	useEffect(() => {
		fetchSubject();
	}, []);

	// Loading state
	if (loading) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "rgba(0, 0, 0, 0.7)",
					backdropFilter: "blur(8px)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					zIndex: 9999,
				}}
			>
				<div
					style={{
						background: "white",
						padding: "40px",
						borderRadius: "16px",
						boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
						textAlign: "center",
					}}
				>
					<div
						style={{
							width: "48px",
							height: "48px",
							border: "4px solid #f3f3f3",
							borderTop: "4px solid #4596a4",
							borderRadius: "50%",
							animation: "spin 1s linear infinite",
							margin: "0 auto 20px",
						}}
					/>
					<div style={{ fontSize: "16px", color: "#666" }}>Loading...</div>
					<style>
						{`
							@keyframes spin {
								0% { transform: rotate(0deg); }
								100% { transform: rotate(360deg); }
							}
						`}
					</style>
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div
				style={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "rgba(0, 0, 0, 0.7)",
					backdropFilter: "blur(8px)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					zIndex: 9999,
				}}
			>
				<div
					style={{
						background: "white",
						padding: "30px",
						borderRadius: "16px",
						boxShadow: "0 8px 32px rgba(0, 0, 0, 0.3)",
						textAlign: "center",
					}}
				>
					<div style={{ fontSize: "48px", marginBottom: "16px" }}>⚠️</div>
					<div style={{ fontSize: "18px", color: "#d32f2f", fontWeight: "600" }}>
						Error: {error}
					</div>
				</div>
			</div>
		);
	}

	const SubjectRow = ({ subject, index }) => (
		<div
			style={{
				display: "flex",
				alignItems: "center",
				padding: "14px 16px",
				borderRadius: "12px",
				background: index % 2 === 0 ? "rgba(255, 255, 255, 0.05)" : "transparent",
				marginBottom: "8px",
				transition: "all 0.2s ease",
			}}
			onMouseEnter={(e) => {
				e.currentTarget.style.background = "rgba(255, 255, 255, 0.1)";
				e.currentTarget.style.transform = "translateX(4px)";
			}}
			onMouseLeave={(e) => {
				e.currentTarget.style.background = index % 2 === 0 ? "rgba(255, 255, 255, 0.05)" : "transparent";
				e.currentTarget.style.transform = "translateX(0)";
			}}
		>
			<div
				style={{
					width: "36px",
					height: "36px",
					borderRadius: "10px",
					background: "rgba(255, 255, 255, 0.15)",
					backdropFilter: "blur(10px)",
					display: "flex",
					justifyContent: "center",
					alignItems: "center",
					marginRight: "14px",
					fontSize: "13px",
					fontWeight: "700",
					color: "#fff",
				}}
			>
				{index + 1}
			</div>
			<div style={{ flex: 1 }}>
				<div
					style={{
						fontSize: "14px",
						color: "#ffffff",
						fontWeight: "600",
						marginBottom: "2px",
					}}
				>
					{subject.subjectName || "-"}
				</div>
				<div
					style={{
						fontSize: "11px",
						color: "rgba(255, 255, 255, 0.6)",
						display: "flex",
						alignItems: "center",
						gap: "4px",
					}}
				>
					<ClassIcon style={{ fontSize: "12px" }} />
					{subject.className || "-"}
				</div>
			</div>
		</div>
	);

	return (
		<div
			className="modal-overlay"
			style={{
				position: "fixed",
				top: 0,
				left: 0,
				right: 0,
				bottom: 0,
				backgroundColor: "rgba(0, 0, 0, 0.75)",
				backdropFilter: "blur(10px)",
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				zIndex: 9999,
				padding: "20px",
			}}
			onClick={onClose}
		>
			<div
				className="modal-content"
				style={{
					background: "linear-gradient(135deg, #080F1F 0%, #102A43 55%, #1B4965 100%)",
					padding: "12px",
					borderRadius: "20px",
					width: "100%",
					maxWidth: "580px",
					maxHeight: "80vh",
					boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(255, 255, 255, 0.1)",
					fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
					position: "relative",
					overflow: "hidden",
					animation: "slideIn 0.3s ease-out",
				}}
				onClick={(e) => e.stopPropagation()}
			>
				<style>
					{`
						@keyframes slideIn {
							from {
								opacity: 0;
								transform: translateY(-20px) scale(0.95);
							}
							to {
								opacity: 1;
								transform: translateY(0) scale(1);
							}
						}
					`}
				</style>

				{/* Decorative accent */}
				<div
					style={{
						position: "absolute",
						top: 0,
						left: 0,
						right: 0,
						height: "4px",
					}}
				/>

				{/* Header */}
				<div
					style={{
						padding: "10px 18px",
						borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
					}}
				>
					<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
						<div
							style={{
								width: "36px",
								height: "36px",
								borderRadius: "10px",
								background: "rgba(255, 255, 255, 0.15)",
								backdropFilter: "blur(10px)",
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
								fontSize: "18px",
							}}
						>
							<SchoolIcon style={{ fontSize: "18px", color: "#fff" }} />
						</div>
						<div>
							<h2
								style={{
									margin: 0,
									fontSize: "18px",
									fontWeight: "700",
									color: "#ffffff",
									letterSpacing: "-0.5px",
								}}
							>
								Class and Subject
							</h2>
							<p
								style={{
									margin: "2px 0 0 0",
									fontSize: "11px",
									color: "rgba(255, 255, 255, 0.6)",
									fontWeight: "400",
								}}
							>
								Course Enrollment Details
							</p>
						</div>
					</div>
				</div>

				{/* Body */}
				<div 
					style={{ 
						padding: "16px 18px",
						maxHeight: "calc(80vh - 160px)",
						overflowY: "auto",
					}}
				>
					{subjectData.length === 0 ? (
						<div
							style={{
								textAlign: "center",
								padding: "40px 20px",
							}}
						>
							<MenuBookIcon 
								style={{ 
									fontSize: "64px", 
									color: "rgba(255, 255, 255, 0.3)",
									marginBottom: "16px"
								}} 
							/>
							<div
								style={{
									fontSize: "16px",
									color: "rgba(255, 255, 255, 0.7)",
									fontWeight: "500",
								}}
							>
								No class or subject records found
							</div>
						</div>
					) : (
						<div>
							{subjectData.map((subject, index) => (
								<SubjectRow key={index} subject={subject} index={index} />
							))}
						</div>
					)}
				</div>

				{/* Footer */}
				<div
					style={{
						padding: "10px 18px",
						borderTop: "1px solid rgba(255, 255, 255, 0.1)",
						background: "rgba(0, 0, 0, 0.2)",
						display: "flex",
						justifyContent: "flex-end",
					}}
				>
					<button
						onClick={onClose}
						style={{
							padding: "9px 22px",
							background: "rgba(255, 255, 255, 0.15)",
							backdropFilter: "blur(10px)",
							border: "1px solid rgba(255, 255, 255, 0.3)",
							borderRadius: "10px",
							color: "#ffffff",
							fontSize: "13px",
							fontWeight: "600",
							cursor: "pointer",
							transition: "all 0.2s ease",
							letterSpacing: "0.3px",
						}}
						onMouseEnter={(e) => {
							e.target.style.background = "rgba(255, 255, 255, 0.25)";
							e.target.style.transform = "translateY(-2px)";
							e.target.style.boxShadow = "0 4px 12px rgba(0, 0, 0, 0.3)";
						}}
						onMouseLeave={(e) => {
							e.target.style.background = "rgba(255, 255, 255, 0.15)";
							e.target.style.transform = "translateY(0)";
							e.target.style.boxShadow = "none";
						}}
					>
						Close
					</button>
				</div>
			</div>
		</div>
	);
}

export default CourseBatchModal;